// extracted by mini-css-extract-plugin
export default {"container":"container-p7r4n","button":"button-SqUd5","noBorder":"noBorder-Sa1l0"};